import { Helmet } from "react-helmet-async";
import config from "config";

interface SeoProps {
    pageName: string
    title: string;
    description: string;
    keywords?: string;
    url?: string;
    image?: string;
}

const trim = (text: string, min: number, max: number) => {
    if (!text) return "";
    if (text.length < min) return text;
    if (text.length > max) return text.substring(0, max - 3) + "...";
    return text;
};

const Seo = ({
    pageName,
    title,
    description,
    keywords = "CRM, Sales, Business, Analytics, Sales Trackify,AI CRM",
    url = config.DOMAIN_URL,
    image = `${config.DOMAIN_URL}/og-image.jpg`,
}: SeoProps) => {

    // const optimizedTitle = trim(title, 40, 60);
    const optimizedTitle = title;
    const optimizedDescription = trim(description, 100, 160);

    return (
        <Helmet>
            {/* Basic SEO */}
            <title>{optimizedTitle}</title>
            <meta name="description" content={optimizedDescription} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            {/* Keywords – DYNAMIC */}

            <meta name="viewport" content="width=device-width, initial-scale=1" />

            {/* Open Graph */}
            <meta property="og:title" content={optimizedTitle} />
            <meta property="og:description" content={optimizedDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="SalesTrackify" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={optimizedTitle} />
            <meta name="twitter:description" content={optimizedDescription} />
            <meta name="twitter:image" content={image} />

            {/* Extra */}
        </Helmet>
    );
};

export default Seo;
